import { css } from "styled-components";
import { BladeHeader, BladeHeaderBody, BladeHeaderSupertitle } from "../../../../components/BladeHeader";
import { textUppercaseMixin } from "../../../../skins/shared/mixins/typography";
export const riotProductSkin = (chroma, paletteTokens) => css `
  & {
    display: flex;
    align-items: flex-end;
    padding: 64px 0;

    ${chroma.mediaQueries.mobileDown} {
      padding: 32px 0;
    }
  }

  ${BladeHeader} {
    padding-top: 96px;
    position: relative;
    display: flex;
    flex-direction: column;
    width: 616px;

    ${chroma.mediaQueries.tabletDown} {
      padding-top: 32px;
      width: 100%;
    }

    ${chroma.mediaQueries.mobileDown} {
      padding-top: 96px;
    }

    ${BladeHeaderSupertitle} {
      ${chroma.typography.body2};
      font-weight: 500;
      color: ${paletteTokens.bladetext1};
      margin-bottom: 4px;
    }

    h1 {
      ${chroma.typography.display3};
      ${textUppercaseMixin};
      color: ${paletteTokens.bladetext1};
    }

    ${BladeHeaderBody} {
      ${chroma.typography.body3};
      color: ${paletteTokens.bladetext1};
      margin-top: 16px;
    }
  }

  .text-masthead--link {
    display: inline-block;
    cursor: pointer;
    margin-top: ${chroma.spacers.variable.m};
  }
`;
//# sourceMappingURL=index.js.map